import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectCommonDealDetailsModalId, selectCommonDealDetails } from '../../selectors/promoInfo';
import { setCommonDealDetailsModalId } from '../../actions';
import { CommonDealDetailsModal, CommonDealDetailsContent } from '../../components/CommonDealDetails';

/**
 * Модалка с часто встречающейся информацией о сделке.
 */
export const CommonDealDetailsModalContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const dispatch = useDispatch();
  const commonDealDetails = useSelector(selectCommonDealDetails);
  const modalId = useSelector(selectCommonDealDetailsModalId);

  const modalContent = modalId ? commonDealDetails[modalId] : undefined;

  const onClose = () => {
    dispatch(setCommonDealDetailsModalId(null));
  };

  if (!modalId || !modalContent) {
    return null;
  }

  return (
    <CommonDealDetailsModal open={true} onClose={onClose} title={modalContent.title}>
      <CommonDealDetailsContent content={modalContent} />
    </CommonDealDetailsModal>
  );
};
